define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports._settings = celuceSettings;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/settings.js
// module id = 46
// module chunks = 0